import { API_URLS } from "@solomon-apps/shared";

export class RateLimitError extends Error {
    retryAfter: number;
    constructor(retryAfter: number) {
        super("Too many requests");
        this.name = "RateLimitError";
        this.retryAfter = retryAfter;
    }
}

interface CreateShareCardResponse {
    shortId: string;
    permalink: string;
    imageUrl: string;
}

export async function createShareCard(params: {
    title: string;
    cardType: string;
    value: string;
    delta: string;
    deltaPeriod: string;
}): Promise<CreateShareCardResponse> {
    const response = await fetch(`${API_URLS.YAAS_METRICS}/api/share-cards`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(params)
    });
    if (response.status === 429) {
        const retryAfter = parseInt(response.headers.get("Retry-After") ?? "60", 10);
        throw new RateLimitError(retryAfter);
    }
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return (await response.json()) as CreateShareCardResponse;
}
